import { LeagueRootService } from '@core/services/league-root.service';
import { TournamentTeamService } from '@core/services/tournament-team.service';
import { SportTypes } from '@mtgame/core';
import { HockeyTournamentTeamService } from '@core/services/hockey-tournament-team.service';
import { BasketballTournamentTeamService } from '@core/services/basketball-tournament-team.service';
import { Injector, Type } from '@angular/core';
import { VolleyballTournamentTeamService } from '@core/services/volleyball-tournament-team.service';
import { FootballTournamentTeamService } from '@core/services/football-tournament-team.service';
import { HandballTournamentTeamService } from '@core/services/handball-tournament-team.service';
import { RugbyTournamentTeamService } from '@core/services/rugby-tournament-team.service';

const services: {[key: number]: Type<TournamentTeamService>} = {
  [SportTypes.hockey]: HockeyTournamentTeamService,
  [SportTypes.basketball]: BasketballTournamentTeamService,
  [SportTypes.volleyball]: VolleyballTournamentTeamService,
  [SportTypes.football]: FootballTournamentTeamService,
  [SportTypes.handball]: HandballTournamentTeamService,
  [SportTypes.rugby]: RugbyTournamentTeamService,
};

export function tournamentTeamFactory(injector: Injector): TournamentTeamService {
  const league = injector.get(LeagueRootService).getLeagueModel();
  if (!services[league.sport.id]) {
    throw new Error('Invalid sport');
  }
  return injector.get(services[league.sport.id]);
}
